// extracted by mini-css-extract-plugin
export var avatar = "_jj-3";
export var avatarContainer = "_jj-2";
export var avatarSpacer = "_jj-5";
export var avatarSpacerContainer = "_jj-4";
export var avatarStackContainer = "_jj-1";
export var bubble = "_jj-0";
export var remainderBubble = "_jj-6";